import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  UPDATE_MANAGER_STANDBY_REQUEST,
  UPDATE_MANAGER_STANDBY_SUCCESS,
  UPDATE_MANAGER_STANDBY_FAILURE
} from "../../Constants";

function requestUpdateStandBy() {
  return {
    type: UPDATE_MANAGER_STANDBY_REQUEST,
    isFetching: true
  };
}

function updateStandBySuccess(data) {
  return {
    type: UPDATE_MANAGER_STANDBY_SUCCESS,
    isFetching: false,
    data
  };
}

function updateStandByError(errorMessage) {
  return {
    type: UPDATE_MANAGER_STANDBY_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const updateManagerStandBy = payload => (dispatch, getState) => {
  dispatch(requestUpdateStandBy());
  managerTimesheet
    .updateStandbyTechnician(payload)
    .then(res => {
      dispatch(updateStandBySuccess(res));
    })
    .catch(err => dispatch(updateStandByError(err)));
};

export const resetStandyMessage = payload => (dispatch, getState) => {
  dispatch(updateStandBySuccess(""));
};
